import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Instagram, Youtube, Facebook, Twitter, Linkedin, Globe, Mail, MessageCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Pick an icon + brand color from the platform name (case-insensitive)
const platformIcon = (platform) => {
  const p = (platform || '').toLowerCase();
  if (p.includes('instagram')) return { Icon: Instagram, color: 'bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500 text-white' };
  if (p.includes('youtube')) return { Icon: Youtube, color: 'bg-red-600 text-white' };
  if (p.includes('facebook')) return { Icon: Facebook, color: 'bg-blue-600 text-white' };
  if (p.includes('twitter') || p === 'x') return { Icon: Twitter, color: 'bg-slate-900 text-white' };
  if (p.includes('linkedin')) return { Icon: Linkedin, color: 'bg-sky-700 text-white' };
  if (p.includes('whatsapp') || p.includes('telegram')) return { Icon: MessageCircle, color: 'bg-green-600 text-white' };
  if (p.includes('email') || p.includes('mail')) return { Icon: Mail, color: 'bg-amber-500 text-white' };
  return { Icon: Globe, color: 'bg-slate-700 text-white' };
};

export const SocialIconsRow = ({ size = 'md' }) => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    axios.get(`${API}/social-links`)
      .then(r => setLinks((r.data || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0))))
      .catch(() => { /* noop */ });
  }, []);

  if (!links.length) return null;

  const sizeMap = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-14 h-14',
  };
  const iconSize = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };
  const wrapClass = sizeMap[size] || sizeMap.md;
  const iconClass = iconSize[size] || iconSize.md;

  return (
    <div data-testid="social-icons-row" className="flex items-center justify-center gap-3 mt-5">
      {links.map(link => {
        const { Icon, color } = platformIcon(link.platform);
        return (
          <a
            key={link.id}
            data-testid={`social-icon-${link.platform.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.platform}
            title={link.platform}
            className={`${wrapClass} ${color} rounded-full flex items-center justify-center shadow-md hover:shadow-xl hover:scale-110 transition-all duration-200`}
          >
            <Icon className={iconClass} />
          </a>
        );
      })}
    </div>
  );
};
